import http from "../http";

export const secretList = params => {
  return http({
    method: "get",
    params,
    url: `/crd.kubestar.io/secrets`
  });
};

export const secretListByLocation = (data, params) => {
  return http({
    method: "get",
    url: `/k8s.kubestar.io/vendors/${data.vendor}/regions/${data.region}/clusters/${data.cluster}/namespaces/${data.namespace}/secrets`,
    params
  });
};

export const secretSubmit = (data, headers) => {
  return http({
    method: "post",
    url: `/k8s.kubestar.io/namespaces/${data.metadata.namespace}/secrets`,
    data,
    headers
  });
};

export const secretDetail = data => {
  return http({
    method: "get",
    url: `/k8s.kubestar.io/vendors/${data.vendor}/regions/${data.region}/clusters/${data.cluster}/namespaces/${data.namespace}/secrets/${data.secret}`
  });
};

export const secretUpdate = (data, headers) => {
  return http({
    method: "put",
    url: `/k8s.kubestar.io/namespaces/${data.metadata.namespace}/secrets/${data.metadata.name}`,
    data,
    headers
  });
};

export const secretDelete = data => {
  return http({
    method: "delete",
    url: `/k8s.kubestar.io/vendors/${data.vendor}/regions/${data.region}/clusters/${data.cluster}/namespaces/${data.namespace}/secrets/${data.name}`
  });
};

export const createImagePullSecrets = (data, namespace, headers) => {
  return http({
    method: "post",
    url: `/k8s.kubestar.io/namespaces/${namespace}/registry/secrets`,
    data,
    headers
  });
};
